import React, { Dispatch, useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import { ChatFolderData } from "@sms/shared/chat/chat-folder.interface";
import { useDispatch, useSelector } from "react-redux";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";

import { ChatFoldersState } from "./chat-folders.types";
import styles from "./chat-folders.module.scss";
import FolderAddButton from "./folder-add-button/folder-add-button.component";
import ChatFolderItem from "./folder-item/folder-item.component";

import { ApplicationStore } from "~/app/application.store";
import { setCurrentFolderAction } from "~/app/chat/folders/folders.actions";
import { setChatFolderModalIsOpen, setChatSelectFolderSettingModalIsOpen } from "~/app/modals/modals.actions";
import archiveActions from "~/app/chat/archive/archive.actions";

const ChatFoldersComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const folders: ChatFolderData[] = useSelector((state: ApplicationStore) => state.chatFolders.folders);
  const currentFolder: ChatFolderData | null = useSelector(
    (state: ApplicationStore) => state.chatFolders.currentFolder
  );
  const chats: ChatWithShortInfo[] = useSelector((state: ApplicationStore) => state.chats.chats);
  const chatsCountAllNotifications: number = useSelector(
    (state: ApplicationStore) => state.chats.chatsCountAllNotifications
  );
  const isArchivedFolder: boolean = useSelector((state: ApplicationStore) => state.archive.isArchived);

  const [foldersData, setFoldersData]: [ChatFoldersState, React.Dispatch<React.SetStateAction<ChatFoldersState>>] =
    useState<ChatFoldersState>({ folders: [] });
  const [countNotificationsAll, setCountNotificationsAll]: [number, React.Dispatch<React.SetStateAction<number>>] =
    useState<number>(0);

  useEffect(() => {
    setFoldersData({
      folders: folders
    });
  }, [folders]);

  const setChatFolder: (chatFolder: ChatFolderData | null) => void = useCallback(
    (chatFolder: ChatFolderData | null) => {
      dispatch(setCurrentFolderAction(chatFolder));
    },
    [dispatch]
  );
  const handleChatFolderModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean) => {
      dispatch(setChatFolderModalIsOpen(isOpen));
    },
    [dispatch]
  );
  const handleChatSelectFolderSettingModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean) => {
      dispatch(setChatSelectFolderSettingModalIsOpen(isOpen));
    },
    [dispatch]
  );
  const handleSwitchToArchivedFolder: (isArchived: boolean) => void = useCallback(
    (isArchived: boolean) => {
      dispatch(archiveActions.handleSwitchToArchiveFolder(isArchived));
    },
    [dispatch]
  );

  const handleChangeCurrentFolder: (chatFolder: ChatFolderData | null) => void = (
    chatFolder: ChatFolderData | null
  ) => {
    setChatFolder(chatFolder);
  };

  useEffect(() => {
    setCountNotificationsAll(chatsCountAllNotifications);
  }, [chatsCountAllNotifications]);

  return (
    <div className={styles.foldersWrapper}>
      <ChatFolderItem
        className={classNames(styles.tabFolder, currentFolder == null ? styles.active : "")}
        folderItem={{
          id: "All",
          title: isArchivedFolder !== true ? "All" : "Archive",
          position: -1,
          notifications: countNotificationsAll
        }}
        chats={chats}
        currentFolder={currentFolder}
        classNameSetting={classNames(styles.settingChatFolder)}
        handleChangeCurrentFolder={handleChangeCurrentFolder}
        handleChatSelectFolderSettingModalIsOpen={handleChatSelectFolderSettingModalIsOpen}
        handleSwitchToArchivedFolder={handleSwitchToArchivedFolder}
        isArchivedFolder={isArchivedFolder}
      />

      {foldersData.folders.map((folder, key) => {
        return (
          <ChatFolderItem
            key={key}
            className={classNames(styles.tabFolder, currentFolder?.id == folder.id ? styles.active : "")}
            classNameSetting={classNames(styles.settingChatFolder)}
            currentFolder={currentFolder}
            folderItem={folder}
            chats={chats}
            handleChangeCurrentFolder={handleChangeCurrentFolder}
            handleChatSelectFolderSettingModalIsOpen={handleChatSelectFolderSettingModalIsOpen}
            handleSwitchToArchivedFolder={handleSwitchToArchivedFolder}
            isArchivedFolder={isArchivedFolder}
          />
        );
      })}
      <FolderAddButton chatFolderModalIsOpen={handleChatFolderModalIsOpen} />
    </div>
  );
};

export default ChatFoldersComponent;
